module.exports = __webpack_public_path__ + "static/media/mpt.f0c67e72.svg";